import {
  DocumentCategoriesListListData,
  documentCategoriesListListInfiniteOptions,
  Dropdown,
  LeadsListListData,
  leadsListListInfiniteOptions,
  PaginatedDropdownList
} from '@crm/api'
import { InfiniteSelect } from '@crm/components'
import {
  defaultFiltersMultipleValues,
  defaultFiltersNumberValues
} from '@crm/utils'
import { useQueryUpdate } from '@shared/hooks'
import { useTranslation } from 'react-i18next'

export const DocumentsFilter = () => {
  const { params, updateQuery } = useQueryUpdate()

  const { t } = useTranslation()
  const valueCategory = defaultFiltersNumberValues(params?.category)
  const leadValue = defaultFiltersMultipleValues(params?.lead, true)

  return (
    <>
      <InfiniteSelect<
        DocumentCategoriesListListData,
        PaginatedDropdownList,
        Dropdown
      >
        value={valueCategory}
        className="select-min-width"
        popupMatchSelectWidth
        placeholder={t('filter.category')}
        getQueryFunction={documentCategoriesListListInfiniteOptions}
        onChange={(category) => updateQuery({ category })}
        baseOptions={{
          query: {
            preference: params?.category
          }
        }}
      />

      <InfiniteSelect<LeadsListListData, PaginatedDropdownList, Dropdown>
        value={leadValue}
        className="select-min-width"
        popupMatchSelectWidth
        mode="multiple"
        placeholder={t('filter.leads')}
        getQueryFunction={leadsListListInfiniteOptions}
        onChange={(lead) => updateQuery({ lead })}
        baseOptions={{
          query: {
            preference: params?.lead
          }
        }}
        maxTagCount={1}
        maxTagTextLength={6}
      />
    </>
  )
}
